import {
  walletInfoRC,
  memberInfoRC,
  isWalletFullScreenFromUrlOrStorage,
  CASHIER_COUNTER_TOKEN_WALLET_TAB_KEY,
  CASHIER_PAYMENT_LOADING_TO_WALLET_TAB_KEY,
  CW_BOOTSTRAP_PLACE_WALLET_GATE_KEY,
  CW_BOOTSTRAP_BLOCK_COUNTER_DEPOSIT_PW_KEY,
  CW_BOOTSTRAP_MINE_HEAD_PREFETCHED_SESSION_KEY,
  CW_BOOTSTRAP_MINE_HEAD_PREFETCH_IN_FLIGHT_KEY,
  CW_BOOTSTRAP_MINE_BALANCE_SPIN_STARTED_AT_KEY,
} from './data';
import { queryPayTypeInfo, authChatCreateSingleLink } from '@/api/wallet';
import { runEvent } from '@/utils/wallet/event';
import { sendMessageToNative } from '@/utils/base';
/**
 * 获取聊天室的域名
 */
export const getChatRoomDomain = () => {
  return location.origin.includes('localhost') ? 'https://cplay.zfs23598.com/' : location.origin.replace(location.hostname.split('.')[0], 'cplay');
};

/**
 * 68 内嵌：绑定收款成功页与买卖页常分属两个 WebView。
 * 成功时 bump localStorage，其它页监听 storage 后刷新（同源多 WebView 共享，无需拼会员 id）。
 */
export const WALLET_EMBEDDED_PAY_LIST_SYNC_KEY = 'walletEmbeddedPayAccountSync';

/** @deprecated 请用 WALLET_EMBEDDED_PAY_LIST_SYNC_KEY */
export const WALLET_EMBEDDED_PAY_LIST_SYNC_PREFIX = WALLET_EMBEDDED_PAY_LIST_SYNC_KEY;

export const bumpWalletEmbeddedPayListSync = () => {
  try {
    localStorage.setItem(WALLET_EMBEDDED_PAY_LIST_SYNC_KEY, String(Date.now()));
  } catch {
    //
  }
};

const normalizeDomain = domain => {
  if (!domain || typeof domain !== 'string') {
    window.$toast && window.$toast('聊天室域名缺失');
    return '';
  }
  const trimmed = domain.trim();
  if (!/^https?:\/\//i.test(trimmed) || trimmed === 'null' || trimmed.startsWith('file:')) {
    window.$toast && window.$toast('聊天室域名异常');
    return '';
  }
  return trimmed.endsWith('/') ? trimmed : `${trimmed}/`;
};

const isValidHttpUrl = url => {
  if (!url || typeof url !== 'string') {
    return false;
  }
  try {
    const parsed = typeof URL === 'function' ? new URL(url) : null;
    return parsed ? /^https?:$/i.test(parsed.protocol) : /^https?:\/\//i.test(url);
  } catch {
    return false;
  }
};

const buildUrl = (baseDomain, params, noEncodeKeys) => {
  const base = normalizeDomain(baseDomain);
  if (!base) {
    return '';
  }
  const query = buildQuery(params, noEncodeKeys);
  const candidate = query ? `${base}?${query}` : base;
  if (isValidHttpUrl(candidate)) {
    return candidate;
  }
  window.$toast && window.$toast('聊天室链接生成失败');
  return '';
};

const buildQuery = (params, noEncodeKeys = []) => {
  return Object.keys(params)
    .filter(key => params[key] !== undefined && params[key] !== null)
    .map(key => {
      const value = String(params[key]);
      if (noEncodeKeys.includes(key)) {
        return `${key}=${value}`;
      }
      return `${key}=${encodeURIComponent(value)}`;
    })
    .join('&');
};

/**
 * 获取支付账户列表
 */
export const getPaymentAccountList = async getLocalListAndId => {
  // 获取会员id
  const { sourceMemberId } = walletInfoRC();

  // 获取本地缓存的支付账户列表
  const paymentAccountListStr = localStorage.getItem('paymentAccountList' + sourceMemberId);

  // 如果需要获取本地的信息，则直接先返回
  if (paymentAccountListStr && getLocalListAndId) {
    try {
      const paymentAccountList = JSON.parse(paymentAccountListStr);

      getLocalListAndId(paymentAccountList);
    } catch {
      // 防止意外导致的异常影响用户使用
    }
  }

  // 接口获取支付账户列表，确保最新
  const paymentAccountList = await queryPayTypeInfo();

  if (paymentAccountList) {
    // 如果发生了改变，则更新本地缓存
    const paymentAccountListStrNew = JSON.stringify(paymentAccountList);

    if (paymentAccountListStrNew !== paymentAccountListStr) {
      localStorage.setItem('paymentAccountList' + sourceMemberId, paymentAccountListStrNew);
    }

    // 返回支付账户列表和默认支付账户id
    return paymentAccountList;
  }

  return null;
};

/**
 * 外部跳转页面
 * - 普通 /wallet：预开窗或 window.open（沿用浏览器逻辑）
 * - /wallet-embedded：仅 68 App 原生壳，postback 交给 App 打开外链
 */
export const jumpToOutsideWebPage = ({ url }, newWindow) => {
  try {
    document.activeElement?.blur();
  } catch {}

  const isWalletEmbedded = typeof location !== 'undefined' && location.pathname.indexOf('/wallet-embedded') === 0;
  // 仅 /wallet-embedded 走父级/原生通讯；/wallet 等与改动前完全一致

  if (!isWalletEmbedded) {
    if (newWindow) {
      localStorage.setItem('paymentUrl', url);
      setTimeout(() => {
        newWindow.location.replace(url);
      }, 50);
    } else {
      window.open(url, '_blank');
    }
    return;
  }
  document.location = `postback://type=open@pre=${url.slice(0, url.indexOf('://'))}@url=${url.slice(url.indexOf('://') + 3)}`;

  // alert(openPostback);
  // // 与 toUrl 一致走 iframe postback，避免与紧随其后的 sendMessageToNative(toUrl) 抢 document.location 导致外跳未执行
  // sendMessageToNative(openPostback);
};

/**
 * 内嵌壳：与打开 order-cashier 相同（docking.js：type=toUrl@page=@pre=@url=）
 * @param {string} page 原生 page：聊天室 chatRoom、收银台 orderCashier 等（见 docking.js）
 * @param {string} fullHttpsUrl 完整 https 链接
 * @param {object} [opts]
 * @param {boolean} [opts.encodeUrlPart] 为 true 时对 url 段 encodeURIComponent，避免 ?、& 打断原生解析；原生需 decode 一次
 */
export const sendEmbeddedToUrlPostback = (page, fullHttpsUrl, opts = {}) => {
  if (!fullHttpsUrl || typeof fullHttpsUrl !== 'string') {
    return;
  }
  const sep = fullHttpsUrl.indexOf('://');
  if (sep === -1) {
    return;
  }
  const pre = fullHttpsUrl.slice(0, sep).replace(':', '') || 'https';
  let urlPart = fullHttpsUrl.slice(sep + 3);
  if (opts.encodeUrlPart) {
    urlPart = encodeURIComponent(urlPart);
  }
  sendMessageToNative(`postback://type=toUrl@page=${page}@pre=${pre}@url=${urlPart}`);
};

/**
 * 内嵌壳打开 `/wallet-embedded/order-cashier` 时的 query 串（与买单 toUrl 一致）。
 * App 通过 toUrl 新开 WebView 时常与买卖页不同上下文，URL 须带 mchId/accessToken 等登录参数。
 *
 * @param {object} [options]
 * @param {string} [options.jumpType] 收银台 tab：1 买入 2 卖出
 * @param {string} [options.tradeType] 与既有约定一致，默认 1
 */
export const buildEmbeddedOrderCashierQueryString = ({ jumpType = '1', tradeType = '1' } = {}) => {
  const { mchId, sourceMemberId, accessToken, randomKey, walletMemberId } = walletInfoRC() || {};
  return [
    `tradeType=${tradeType}`,
    `jumpType=${jumpType}`,
    `mchId=${mchId}`,
    `sourceMemberId=${sourceMemberId}`,
    `accessToken=${encodeURIComponent(accessToken || '')}`,
    `randomKey=${encodeURIComponent(randomKey || '')}`,
    `walletMemberId=${walletMemberId}`,
    'plat=1',
  ].join('&');
};

/**
 * 内嵌购买外跳：买卖页同时通知 App（原 order-cashier 内外跳合并到此）
 * 1. open → 三方 takeOffParam（先执行）
 * 2. 延时 1s 后 toUrl → order-cashier（sendMessageToNative，避免与 open 抢 document.location）
 */
export const sendEmbeddedOpenOrderCashierAndTakeOff = ({ takeOffParam, jumpType = '1', tradeType = '1' } = {}) => {
  const openOrderCashier = () => {
    const cashierUrl = `https://${location.host}/wallet-embedded/order-cashier?${buildEmbeddedOrderCashierQueryString({ jumpType, tradeType })}`;
    sendEmbeddedToUrlPostback('orderCashier', cashierUrl);
  };
  if (takeOffParam) {
    jumpToOutsideWebPage({ url: takeOffParam }, null);
    setTimeout(openOrderCashier, 1000);
    return;
  }
  openOrderCashier();
};

/**
 * 生成钱包进聊天室的 https 链接（与 jumpToIM 实际跳转 URL 一致，无副作用）
 */
export const buildJumpToIMWalletUrl = ({ relationOrderTid, orderNo, newWindow } = {}, numType) => {
  const chatRoomDomain = getChatRoomDomain();
  const { mchId, randomKey, accessToken, isFullScreen, plat, iosApp } = walletInfoRC();
  const bh = isFullScreen || isWalletFullScreenFromUrlOrStorage() ? 1 : 0;
  return buildUrl(
    chatRoomDomain,
    {
      type: 'wallet',
      tid: relationOrderTid || orderNo,
      mchId,
      token: accessToken,
      randomKey,
      noback: 1,
      bh,
      imJumpSceneType: numType || 1,
      newWindow: newWindow ? 1 : undefined,
      imJumpType: relationOrderTid ? 1 : undefined,
      plat,
      iosApp,
    },
    ['token', 'randomKey']
  );
};

const isWalletEmbeddedPath = () => typeof location !== 'undefined' && location.pathname.indexOf('/wallet-embedded') === 0;

/**
 * 钱包进聊天室：内嵌 68 走 toUrl（与买单 uiType=3 一致）；H5 走 location.href / newWindow
 */
export const jumpToIMWithEmbeddedToUrl = (params, numType) => {
  const payload = params || {};
  if (isWalletEmbeddedPath()) {
    const chatUrl = buildJumpToIMWalletUrl(payload, numType);
    if (!chatUrl) {
      window.$toast?.({ type: 'error', text: '聊天室链接生成失败' });
      return;
    }
    localStorage.setItem('backUrl', `${location.origin}/wallet-embedded/order-cashier?${buildEmbeddedOrderCashierQueryString()}`);
    localStorage.setItem('isBack', '1');
    let chatUrlForNative = chatUrl;
    try {
      const u = new URL(chatUrl);
      u.searchParams.set('walletEmbeddedOrigin', location.origin);
      chatUrlForNative = u.toString();
    } catch {
      //
    }
    sendEmbeddedToUrlPostback('chatRoom', chatUrlForNative);
    return;
  }
  jumpToIM(payload, numType);
};

/**
 * 跳转聊天室
 * buyMchId 购买下单跳炸聊天室的时候，写死 9991商户id
 */
export const jumpToIM = ({ relationOrderTid, orderNo, newWindow }, numType) => {
  // 保存当前页面路径 用来返回
  localStorage.setItem('backUrl', location.pathname + location.search);

  const url = buildJumpToIMWalletUrl({ relationOrderTid, orderNo, newWindow }, numType);
  if (!url) {
    return;
  }
  // 如果存在新窗口，则停止心跳并跳转新窗口
  if (newWindow) {
    // pingParentPageStop();

    newWindow.location.replace(url);
    return;
  }
  // 如果有前置路由 则替换当前页面
  if (location.hash.includes('#2')) {
    location.replace(url);
  } else {
    // 停止心跳
    // pingParentPageStop();

    // 设置返回记录
    localStorage.setItem('isBack', '1');

    // 跳转
    location.href = url;
  }
};

/**
 * 钱包跳聊天室
 */
export const walletJumpIM = params => {
  // 获取钱包信息
  const { mchId, randomKey, accessToken, plat, isFullScreen, iosApp } = walletInfoRC();

  // 获取域名
  const domain = getChatRoomDomain();

  // 保存当前页面路径 用来返回
  localStorage.setItem('backUrl', location.pathname + location.search);

  // 与钱包布局一致：walletInfo.isFullScreen + 当前 URL/localStorage 的 bh
  const bh = isFullScreen || isWalletFullScreenFromUrlOrStorage() ? 1 : 0;

  let url = buildUrl(
    domain,
    {
      type: 'wallet',
      tid: params.relationOrderTid || params.tid,
      mchId,
      token: accessToken,
      randomKey,
      imJumpSceneType: params.imJumpSceneType,
      noback: params.noback,
      bh,
      imJumpType: params.relationOrderTid ? 1 : undefined,
      plat,
      iosApp,
    },
    ['token', 'randomKey']
  );

  if (!url) {
    return;
  }

  const isEmbeddedOrderCashier = location.pathname === '/wallet-embedded/order-cashier' || location.pathname.startsWith('/wallet-embedded/order-cashier/');
  if (isEmbeddedOrderCashier) {
    try {
      const u = new URL(url);
      u.searchParams.set('walletEmbeddedOrigin', location.origin);
      url = u.toString();
    } catch {
      // keep url
    }
  }

  if (location.hash.includes('#2')) {
    // 替换当前页面
    location.replace(url);
  } else {
    // 停止心跳
    // pingParentPageStop();

    // 设置返回记录
    localStorage.setItem('isBack', '1');

    // 跳转
    location.href = url;
  }
};

const clearWalletLoginState = () => {
  walletInfoRC(null);
  memberInfoRC(null);
  localStorage.removeItem('walletInfo');
  localStorage.removeItem('memberInfo');
  sessionStorage.removeItem('innerWalletLogined');
  sessionStorage.removeItem('counterToWalletDepostParams');
  sessionStorage.removeItem(CW_BOOTSTRAP_PLACE_WALLET_GATE_KEY);
  sessionStorage.removeItem(CW_BOOTSTRAP_BLOCK_COUNTER_DEPOSIT_PW_KEY);
  sessionStorage.removeItem(CW_BOOTSTRAP_MINE_HEAD_PREFETCHED_SESSION_KEY);
  sessionStorage.removeItem(CW_BOOTSTRAP_MINE_HEAD_PREFETCH_IN_FLIGHT_KEY);
  sessionStorage.removeItem(CW_BOOTSTRAP_MINE_BALANCE_SPIN_STARTED_AT_KEY);
  sessionStorage.removeItem(CASHIER_COUNTER_TOKEN_WALLET_TAB_KEY);
  sessionStorage.removeItem(CASHIER_PAYMENT_LOADING_TO_WALLET_TAB_KEY);
};

/**
 * 退出登录 到登录页面
 */
export const logoutToLogin = () => {
  clearWalletLoginState();
  location.href = '/wallet/mine';
};

/**
 * 收银台浏览器新开标签：过期后清空状态并关闭窗口，不跳转登录页；关窗被拒时退回上一页，避免清空态误显示钱包登录。
 */
export const logoutCashierWebWalletCloseTabAfterExpire = () => {
  clearWalletLoginState();
  window.close();
  setTimeout(() => {
    try {
      if (!document.hidden && window.history.length > 1) {
        window.history.back();
      }
    } catch {
      //
    }
  }, 450);
};

/**
 * 密码必须为 8~16 位字母和数字组合
 */
export const validateNewPassword = password => {
  // 验证账户名格式 6-16 位字母和数字组合
  return /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/.test(password);
};

/**
 * 钱包联系客服
 */
export const handleShowServies = onClose => {
  // 显示加载
  window.$loading(true);
  // 获取客服url
  authChatCreateSingleLink({})
    .then(res => {
      if (res) {
        // 设置客服url
        if (typeof onClose === 'function') {
          onClose();
        }
        runEvent('setChatServiesUrl', {
          url: res,
          from: 'wallet',
        });
      }
    })
    .catch(err => {
      console.log(err, 'err');
    })
    .finally(() => {
      // 关闭加载
      window.$loading(false);
    });
};
